/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Devices_BodyInputs */

const en_why_listening_devices_body = /** @type {(inputs: Why_Listening_Devices_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the browser, on any phone or desktop, with the Chrome extension, in your car, or even on your watch. One subscription covers all of it, and your progress follows you.`)
};

const es_why_listening_devices_body = /** @type {(inputs: Why_Listening_Devices_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el navegador, en cualquier móvil u ordenador, con la extensión de Chrome, en el coche o incluso en tu reloj. Una sola suscripción lo cubre todo y tu progreso te acompaña.`)
};

/**
* | output |
* | --- |
* | "In the browser, on any phone or desktop, with the Chrome extension, in your car, or even on your watch. One subscription covers all of it, and your progress ..." |
*
* @param {Why_Listening_Devices_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_devices_body = /** @type {((inputs?: Why_Listening_Devices_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Devices_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_devices_body(inputs)
	return en_why_listening_devices_body(inputs)
});